import __cloneDeep from 'lodash/cloneDeep';

import {
  INIT,
  UPDATE,
  RESET_NAMESPACE,
  SET_PREVIOUS_CONTENT
} from './types';

export default {
  [INIT](state, { content, hasBundle, rootGetters }) {
    state.content = content;

    if (!hasBundle) {
      content.forEach((entry) => {
        if (entry.quantity && entry.relationships) {
          if (entry.relationships.block) {
            entry.relationships.block.forEach((blockPath) => {
              if (blockPath.endsWith('*')) {
                const relativeBlockPath = blockPath.replace('.*', '');

                state.content.filter(item => item.path.startsWith(relativeBlockPath)).forEach((item) => {
                  item.quantity = 0;
                  item.config.disabled = entry.quantity > 0;
                });
              } else {
                state.content.filter(item => item.path === blockPath).forEach((item) => {
                  item.quantity = 0;
                  item.config.disabled = entry.quantity > 0;
                });
              }
            });
          }

          if (entry.relationships.exclude) {
            entry.relationships.exclude.forEach((excludePath) => {
              if (excludePath.endsWith('*')) {
                const relativeExcludePath = excludePath.replace('.*', '');

                state.content.filter(item => item.quantity && item.path.startsWith(relativeExcludePath)).forEach((item) => {
                  item.quantity = 0;
                });
              } else {
                state.content.filter(item => item.quantity && item.path === excludePath).forEach((item) => {
                  item.quantity = 0;
                });
              }
            });
          }

          if (entry.relationships.hide) {
            entry.relationships.hide.forEach((hidePath) => {
              if (hidePath.endsWith('*')) {
                const relativeHidePath = hidePath.replace('.*', '');

                state.content.filter(item => item.path.startsWith(relativeHidePath)).forEach((item) => {
                  item.quantity = 0;
                  item.config.disabled = true;
                  item.config.hidden = true;
                });
              } else {
                state.content.filter(item => item.path === hidePath).forEach((item) => {
                  item.quantity = 0;
                  item.config.disabled = true;
                  item.config.hidden = true;
                });
              }
            });
          }

          if (entry.relationships.include) {
            if (entry.quantity) {
              entry.relationships.include.forEach((includePath) => {
                state.content.filter(item => item.path === includePath).forEach((item) => {
                  item.quantity = 1;
                });
              });
            } else {
              entry.relationships.include.forEach((includePath) => {
                const peerIncludes = state.content.filter(item => item.quantity > 0 && item.relationships && item.relationships.include && item.relationships.include.indexOf(includePath) > -1);

                if (peerIncludes.length === 0) {
                  state.content.filter(item => item.path === includePath).forEach((item) => {
                    item.quantity = 0;
                  });
                }
              });
            }
          }

          if (entry.relationships.show) {
            entry.relationships.show.forEach((showPath) => {
              if (showPath.endsWith('*')) {
                const relativeshowPath = showPath.replace('.*', '');

                state.content.filter(item => item.path.startsWith(relativeshowPath)).forEach((item) => {
                  item.config.hidden = false;
                  item.config.disabled = false;
                });
              } else {
                state.content.filter(item => item.path === showPath).forEach((item) => {
                  item.config.hidden = false;
                  item.config.disabled = false;
                });
              }
            });
          }
        }

        const relationships = rootGetters['relationships/getContent'];
        const isPathActive = rootGetters['cart/isPathActive'];
        const relevantRelationships = relationships.filter(relationship => relationship.conditions.includes(entry.path));

        if (entry.quantity && relevantRelationships.length) {
          relevantRelationships.forEach((relationship) => {
            let conditionsLeft = relationship.conditions.length;

            relationship.conditions.forEach((conditionPath) => {
              if (isPathActive(conditionPath)) {
                conditionsLeft -= 1;
              }
            });

            if (conditionsLeft === 0) {
              if (relationship.block) {
                relationship.block.forEach((includePath) => {
                  state.content.filter(item => item.path === includePath).forEach((item) => {
                    item.quantity = 0;
                    item.config.disabled = true;
                  });
                });
              }

              if (relationship.include) {
                relationship.include.forEach((includePath) => {
                  state.content.filter(item => item.path === includePath).forEach((item) => {
                    item.quantity = 1;
                  });
                });
              }

              if (relationship.hide) {
                relationship.hide.forEach((hidePath) => {
                  state.content.filter(item => item.path === hidePath).forEach((item) => {
                    item.quantity = 0;
                    item.config.disabled = true;
                    item.config.hidden = true;
                  });
                });
              }

              if (relationship.show) {
                relationship.show.forEach((showPath) => {
                  state.content.filter(item => item.path === showPath).forEach((item) => {
                    item.config.hidden = false;
                    item.config.disabled = false;
                  });
                });
              }
            }
          });
        }
      });
    }
  },

  [RESET_NAMESPACE](state, namespace) {
    const peers = state.content.filter(item => item.config.namespace === namespace && item.quantity > 0);

    peers.forEach((item) => {
      const subPeers = state.content.filter(subItem => subItem.config.parent === item.path);

      if (item.relationships) {
        if (item.relationships.block) {
          item.relationships.block.forEach((blockPath) => {
            state.content.filter(peerItem => peerItem.path === blockPath).forEach((peerItem) => {
              peerItem.config.disabled = false;
            });
          });
        }
      }

      if (item.relationships) {
        if (item.relationships.hide) {
          item.relationships.hide.forEach((hidePath) => {
            state.content.filter(peerItem => peerItem.path === hidePath).forEach((peerItem) => {
              peerItem.config.disabled = false;
              peerItem.config.hidden = false;
            });
          });
        }
      }

      subPeers.forEach((subItem) => {
        subItem.quantity = 0;
      });

      item.quantity = 0;
    });
  },

  [UPDATE](state, { path, quantity, uniqueInNamespace, provenance, rootGetters }) {
    const [target] = state.content.filter(item => item.path === path);

    // backup cart
    state.previousContent = __cloneDeep(state.content);

    target.quantity = quantity;
    // eslint-disable-next-line
    target.provenance = provenance ? provenance : 'manual';


    if (uniqueInNamespace) {
      const peers = state.content.filter(item => item.path !== path && item.config.namespace === target.config.namespace && item.quantity > 0 && item.config.type === target.config.type);
      peers.forEach((item) => {
        const subPeers = state.content.filter(subItem => subItem.config.parent === item.path);

        if (item.relationships) {
          if (item.relationships.block) {
            item.relationships.block.forEach((blockPath) => {
              state.content.filter(peerItem => peerItem.path === blockPath).forEach((peerItem) => {
                peerItem.config.disabled = false;
              });
            });
          }

          if (item.relationships.hide) {
            item.relationships.hide.forEach((hidePath) => {
              state.content.filter(peerItem => peerItem.path === hidePath).forEach((peerItem) => {
                peerItem.config.disabled = false;
                peerItem.config.hidden = false;
              });
            });
          }
        }

        subPeers.forEach((subItem) => {
          subItem.quantity = 0;
        });

        item.quantity = 0;
      });
    }

    if (target.relationships) {
      if (quantity === 0 && target.relationships.dependencies) {
        target.relationships.dependencies.forEach((dependencyPath) => {
          if (dependencyPath.endsWith('*')) {
            const relativeDependencyPath = dependencyPath.replace('.*', '');
            state.content.filter(item => item.path.startsWith(relativeDependencyPath)).forEach((item) => {
              item.quantity = 0;
            });
          } else {
            state.content.filter(item => item.path === dependencyPath).forEach((item) => {
              item.quantity = 0;
            });
          }
        });
      }

      if (target.relationships.block) {
        target.relationships.block.forEach((blockPath) => {
          if (blockPath.endsWith('*')) {
            const relativeBlockPath = blockPath.replace('.*', '');
            state.content.filter(item => item.path.startsWith(relativeBlockPath)).forEach((item) => {
              const includedInOtherItems = !!state.content.filter(cartItem => cartItem.quantity > 0 && cartItem.relationships && cartItem.relationships.include && cartItem.relationships.include.includes(blockPath)).length;
              item.quantity = includedInOtherItems ? item.quantity : 0;
              item.config.disabled = quantity > 0;
            });
          } else {
            state.content.filter(item => item.path === blockPath).forEach((item) => {
              const includedInOtherItems = !!state.content.filter(cartItem => cartItem.quantity > 0 && cartItem.relationships && cartItem.relationships.include && cartItem.relationships.include.includes(blockPath)).length;
              item.quantity = includedInOtherItems ? item.quantity : 0;
              item.config.disabled = quantity > 0;
            });
          }
        });
      }

      if (target.relationships.exclude) {
        target.relationships.exclude.forEach((excludePath) => {
          if (excludePath.endsWith('*')) {
            const relativeExcludePath = excludePath.replace('.*', '');

            state.content.filter(item => item.quantity && item.path.startsWith(relativeExcludePath)).forEach((item) => {
              item.quantity = 0;
            });
          } else {
            state.content.filter(item => item.quantity && item.path === excludePath).forEach((item) => {
              item.quantity = 0;
            });
          }
        });
      }

      if (target.relationships.hide) {
        target.relationships.hide.forEach((hidePath) => {
          if (hidePath.endsWith('*')) {
            const relativeHidePath = hidePath.replace('.*', '');

            state.content.filter(item => item.path.startsWith(relativeHidePath)).forEach((item) => {
              item.quantity = 0;
              item.config.disabled = true;
              item.config.hidden = true;
            });
          } else {
            state.content.filter(item => item.path === hidePath).forEach((item) => {
              item.quantity = 0;
              item.config.disabled = true;
              item.config.hidden = true;
            });
          }
        });
      }

      if (target.relationships.include) {
        if (quantity) {
          target.relationships.include.forEach((includePath) => {
            state.content.filter(item => item.path === includePath).forEach((item) => {
              item.quantity = 1;
              item.provenance = 'manual';
            });
          });
        } else {
          target.relationships.include.forEach((includePath) => {
            const peerIncludes = state.content.filter(item => item.quantity > 0 && item.relationships && item.relationships.include && item.relationships.include.indexOf(includePath) > -1);

            if (peerIncludes.length === 0) {
              state.content.filter(item => item.path === includePath).forEach((item) => {
                item.quantity = 0;
              });
            }
          });
        }
      }

      if (target.relationships.show) {
        target.relationships.show.forEach((showPath) => {
          if (showPath.endsWith('*')) {
            const relativeshowPath = showPath.replace('.*', '');

            state.content.filter(item => item.path.startsWith(relativeshowPath)).forEach((item) => {
              item.config.hidden = false;
              item.config.disabled = false;
            });
          } else {
            state.content.filter(item => item.path === showPath).forEach((item) => {
              item.config.hidden = false;
              item.config.disabled = false;
            });
          }
        });
      }
    }

    const relationships = rootGetters['relationships/getContent'];
    const isPathActive = rootGetters['cart/isPathActive'];
    const relevantRelationships = relationships.filter(relationship => relationship.conditions.includes(target.path));

    if (quantity && relevantRelationships.length) {
      relevantRelationships.forEach((relationship) => {
        let conditionsLeft = relationship.conditions.length;

        relationship.conditions.forEach((conditionPath) => {
          if (isPathActive(conditionPath)) {
            conditionsLeft -= 1;
          }
        });

        if (conditionsLeft === 0) {
          if (relationship.hide) {
            relationship.hide.forEach((hidePath) => {
              state.content.filter(item => item.path === hidePath).forEach((item) => {
                item.quantity = 0;
                item.config.disabled = true;
                item.config.hidden = true;
              });
            });
          }

          if (relationship.show) {
            relationship.show.forEach((showPath) => {
              state.content.filter(item => item.path === showPath).forEach((item) => {
                item.config.hidden = false;
                item.config.disabled = false;
              });
            });
          }
        }
      });
    }
  },

  [SET_PREVIOUS_CONTENT](state) {
    state.content = state.previousContent;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/cart/mutations.js